import localeEn from 'air-datepicker/locale/en'
import localeFr from 'air-datepicker/locale/fr'
import localeDa from 'air-datepicker/locale/da'
import localeNl from 'air-datepicker/locale/nl'
import localeDe from 'air-datepicker/locale/de'
import localeIt from 'air-datepicker/locale/it'
import localePt from 'air-datepicker/locale/pt'
import localeSv from 'air-datepicker/locale/sv'
import localeZh from 'air-datepicker/locale/zh'
import localeJa from 'air-datepicker/locale/ja'
import localePl from 'air-datepicker/locale/pl'
import localeRo from 'air-datepicker/locale/ro'
import localeEs from 'air-datepicker/locale/es'
import localeFi from 'air-datepicker/locale/fi'

const getLocale = (locale) => {
  // Seems like Norwegian is not available yet
  // https://github.com/t1m0n/air-datepicker/tree/v3/dist/locale
  const localeMapping = {
    en: localeEn,
    es: localeEs,
    fr: localeFr,
    da: localeDa,
    nl: localeNl,
    de: localeDe,
    it: localeIt,
    pt: localePt,
    sv: localeSv,
    zh: localeZh,
    ja: localeJa,
    pl: localePl,
    ro: localeRo,
    fi: localeFi,
  }

  return localeMapping[locale] || localeEn
}

export default getLocale
